<template>
    <div class="container" id="Index">
        <header class="header">
            <div>
                <img src="/static/images/logo_l.png" alt="avc-logo" >
                <span style="margin-left: 20px; font-size: 16px;font-family: Futura,sans-serif;">X300 Manager 视频通话</span>
            </div>
            <div style="text-align: right;">
                <img @click="show=2;set_leave()" :src="avatar[userInfo.avatar]" alt="avatar" style="width: 40px; cursor: pointer;">
            </div>
        </header>
        <section class="main">
            <div class="ant-card">
                <div class="ant-card-body" v-show="show==1">
                    <header style="height: 180px; position: relative;">
                        <div style="width: 32px;height: 32px;cursor: pointer;position: absolute;top: 0;right: 0;font-size: 26px">
                            <i @click="show=3;device();" class="el-icon-s-tools"></i>
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; flex-flow: column; height: 100%;">
                            <img src="/static/images/logo.png" alt="logo" style="width: 225px; height: 51px;">
                        </div>
                    </header>

                    <el-form class="ant-form-horizontal" ref="ruleForm" :rules="rules" :model="ruleForm"
                             style="width: 100%; height: 250px; position: relative;">
                        <el-form-item prop="room">
                            <el-input prefix-icon="el-icon-s-home" v-model="value2Computed" placeholder="频道名称">
                            </el-input>
                        </el-form-item>

                        <el-input prefix-icon="el-icon-lock" v-model="ruleForm.password" placeholder="频道密码">
                        </el-input>

                        <el-form-item>
                            <el-checkbox v-model="remember">记住账号和密码</el-checkbox>
                        </el-form-item>

                        <el-button @click="submitMain('ruleForm')" size="small" type="primary" style="width: 100%;position: absolute;bottom: 30px;left: 0;">
                            加入
                        </el-button>
                    </el-form>

                    <div style="text-align: center; cursor: pointer; user-select: none;">
                        <div @click="show_version">{{version[version_num]}}</div>
                    </div>
                </div>

                <div class="ant-card-body" v-show="show==2">
                    <header style="height: 40px;">
                        <div style="display: flex; align-items: center; justify-content: space-around; font-size: 18px;">
                            <i @click="show=1;set_leave()" class="el-icon-back" style="cursor: pointer;"></i>
                            <span style="font-weight: bold; text-align: center; flex-grow: 1;">用户设置</span>
                        </div>
                    </header>
                    <div class="ant-divider-horizontal"></div>
                    <el-form :rules="rule_info" :model="ruleInfoForm" ref="ruleInfoForm" style="width: 100%; position: relative;">
                        <div style="margin-bottom: 0px;">
                            <el-row>
                                <el-col :span="8" class="ant-form-item-label">
                                    <label class="" title="Avatar">头像</label>
                                </el-col>
                                <el-col :span="16">
                                    <div class="ant-form-item-control has-success" @click="dialogVisible = true">
                                        <span style="background-color: rgb(238, 238, 238); border-radius:50%;margin: 6px; cursor: pointer; float: right;">
                                            <img style="width: 32px;height: 32px;" :src="avatar[userInfo.avatar1]"/>
                                        </span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div>
                            <el-row>
                                <el-col :span="8" class="ant-form-item-label">
                                    <label title="Name">*名称</label>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item prop="nickname">
                                        <el-input v-model="ruleInfoForm.nickname" placeholder="你的名称"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="ant-divider-horizontal"></div>
                        <div style="margin-bottom: 0px;">
                            <el-row>
                                <el-col :span="8" class="ant-form-item-label">
                                    <label for="videoEnabled" class="" title="Camera">相机</label>
                                </el-col>
                                <el-col :span="16">
                                    <div>
                                        <span>
                                            <i class="anticon" style="float: right;">
                                                <img alt="video control" @click="userInfo.video = !userInfo.video" :src="userInfo.video?'/static/images/video.png':'/static/images/video1.png'"
                                                     style="width: 40px; height: 40px; cursor: pointer;">
                                            </i>
                                        </span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="margin-bottom: 0px;">
                            <el-row>
                                <el-col :span="8" class="ant-form-item-label">
                                    <label for="audioEnabled" class="" title="Microphone">麦克风</label>
                                </el-col>
                                <el-col :span="16">
                                    <div>
                                        <span>
                                            <i style="float: right;">
                                                <img alt="audio control" @click="userInfo.audio = !userInfo.audio" :src="userInfo.audio?'/static/images/audio.png':'/static/images/audio1.png'"
                                                     style="width: 40px; height: 40px; cursor: pointer;">
                                            </i>
                                        </span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="ant-divider-horizontal"></div>
                        <el-button size="small" @click="submitForm('ruleInfoForm')" type="primary" style="width: 100%;margin-top: 90px;">
                            确认
                        </el-button>
                    </el-form>
                </div>

                <div class="ant-card-body" v-show="show==3">
                    <header style="height: 40px;">
                        <div style="display: flex; align-items: center; justify-content: space-around; font-size: 18px;">
                            <i @click="show=1;set_leave()" class="el-icon-back" style="cursor: pointer;"></i>
                            <span style="font-weight: bold; text-align: center; flex-grow: 1;">设置您的设备</span>
                        </div>
                    </header>

                    <div class="ant-divider-horizontal"></div>

                    <div>
                        <div class="audio-setting">
                            <div class="audio-setting-label">麦克风</div>
                            <div class="audio-setting-desc">
                                <span>发出声音以检查麦克风是否工作。</span>
                            </div>
                            <div class="audio-setting-select ant-select ant-select-enabled">
                                <el-select v-model="audio_id" @change="set_audio">
                                    <el-option
                                            v-for="item in audio"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="video-setting">
                            <div class="video-setting-left">
                                <div class="video-setting-label">Camera</div>
                                <div class="video-setting-desc">
                                    <span>Move in front of the camera to check if it works.</span>
                                </div>
                                <div class="video-setting-select ant-select ant-select-enabled">
                                    <el-select v-model="video_id" @change="set_video">
                                        <el-option
                                                v-for="item in video"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="video-setting-right">
                                <div class="preview-window" :id="preview">

                                </div>
                            </div>
                        </div>
                        <div class="ant-divider-horizontal"></div>
                        <div class="video-setting-label">解析度</div>
                        <el-radio-group v-model="Resolution" @change="set_Profile">
                            <el-radio label="0">低</el-radio>
                            <el-radio label="1">标准</el-radio>
                            <el-radio label="2">高</el-radio>
                        </el-radio-group>
                        <div class="ant-divider-horizontal"></div>
                        <el-button size="small" type="primary" style="width: 100%;">
                            上传日志
                        </el-button>
                        <div class="ant-divider-horizontal"></div>
                        <el-button @click="submitDevice" size="small" type="primary" style="width: 100%;">
                            确认
                        </el-button>
                    </div>
                </div>

                <div class="ant-card-body" v-show="show==4">
                    <header style="height: 180px;">
                        <div style="display: flex; align-items: center; justify-content: space-around; font-size: 18px;">
                            <i @click="show=1;set_leave()" class="el-icon-back" style="cursor: pointer;"></i>
                            <span style="font-weight: bold; text-align: center; flex-grow: 1;">设置名称</span>
                        </div>
                    </header>
                    <el-form :rules="rule_info" :model="ruleInfoForm" ref="ruleInfoForm" style="width: 100%; height: 250px; position: relative;">
                        <el-form-item prop="nickname">
                            <el-input v-model="ruleInfoForm.nickname" placeholder="你的名称">
                                <i slot="prefix" class="el-input__icon el-icon-user"></i>
                            </el-input>
                        </el-form-item>
                        <el-button size="small" @click="submitForm('ruleInfoForm')" type="primary" style="width: 100%;position: absolute;bottom: 30px;">
                            确认
                        </el-button>
                    </el-form>
                    <div style="text-align: center; cursor: pointer; user-select: none;">
                        <div @click="show_version">{{version[version_num]}}</div>
                    </div>
                </div>
            </div>
        </section>

        <el-dialog
                :visible.sync="dialogVisible"
                :show-close="false"
                width="360px"
        >
            <span v-for="(value,key) in avatar" @click="set_avatar(key)" class="ant-avatar ant-avatar-square ant-avatar-image" style="background-color: rgb(238, 238, 238); margin: 6px; cursor: pointer;">
                <el-avatar v-bind:class="{'active':key==userInfo.avatar2}" shape="square" :size="32" :src="value"></el-avatar>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="choose_avatar">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            let validcodeName=(rule,value,callback)=>{
                let reg=/^[0-9A-Z]*$/g;
                if(!reg.test(value)){callback(new Error('Can only contain alphalet in uppercase or number!'))
                }else{
                    callback()
                }
            };
            return {
                //用户信息
                userInfo: {
                    nickname: '',
                    avatar: 0,
                    video: true,
                    audio: true,
                    avatar1:0,
                    avatar2:0,
                },
                preview:'',//图像ID
                show: 1,//默认显示
                dialogVisible: false,//弹窗
                Resolution: "0",//画质
                video_type: [ //画质字典。后期可对应修改
                    '480p_4',
                    '720p_3',
                    '1080p_2',
                ],
                video_id: '', //视频设备ID
                audio_id: '', //音频设备ID
                video: [], //视频设备列表
                audio:[], //音频设备列表
                avatar: [ //头像列表
                    '/static/images/avatar1.png',
                    '/static/images/avatar2.png',
                    '/static/images/avatar3.png',
                    '/static/images/avatar4.png',
                    '/static/images/avatar5.png',
                    '/static/images/avatar6.png',
                    '/static/images/avatar7.png',
                    '/static/images/avatar8.png',
                    '/static/images/avatar9.png',
                    '/static/images/avatar10.png',
                    '/static/images/avatar11.png',
                    '/static/images/avatar12.png',
                    '/static/images/avatar13.png',
                    '/static/images/avatar14.png',
                    '/static/images/avatar15.png',
                    '/static/images/avatar16.png',
                ],
                rules: { //表单验证规则
                    room: [
                        {required: true, message: '请输入频道名称！', trigger: 'blur'},
                        {min: 3, message: 'Room name must be at least 3 characters', trigger: 'blur'},
                        {max: 18, message: 'Room name must not exceed 18 characters', trigger: 'blur'},
                        {validator:validcodeName,trigger:'blur'},
                    ]
                },
                ruleForm: { //表单
                    room: '',
                    password: '',
                },
                rule_info: {
                    nickname: [
                        {required: true, message: 'Please input a nickname!', trigger: 'blur'},
                    ]
                },
                ruleInfoForm: {
                    nickname: '',
                    avatar: '',
                },
                rtc: { //RTC
                    client: null,
                    joined: false,
                    published: false,
                    localStream: null,
                    remoteStreams: [],
                    params: {}
                },
                option: { // 声网appID，后期自行替换
                    appID: "dfd486935afe44c8a10af64c3e06752f",
                },
                stream:'', //流
                version:[ //版本，后期
                    '版本: 1.0.0',
                ],
                remember: false,//记住账号密码
                version_num:0,//默认显示
            }
        },
        mounted(){
            //设置默认值
            let that = this;
            that.userInfo.video = (localStorage.getItem('video') && localStorage.getItem('video')) === 'false' ? false : true;
            that.userInfo.audio = (localStorage.getItem('audio') && localStorage.getItem('audio') === 'false') ? false : true;
            that.userInfo.avatar = that.userInfo.avatar1 = that.userInfo.avatar2 = localStorage.getItem('avatar') ? localStorage.getItem('avatar') : 0;
            that.userInfo.nickname = that.ruleInfoForm.nickname = localStorage.getItem('nickname');

            that.video_id = localStorage.getItem('video_id')?localStorage.getItem('video_id'):'';
            that.audio_id = localStorage.getItem('audio_id')?localStorage.getItem('audio_id'):'';
            if (!localStorage.getItem('resolution'))
                localStorage.setItem('resolution',"0");
            that.Resolution = localStorage.getItem('resolution');

            //RTC RTM 版本
            that.version.push('RTC: '+that.AgoraRTC.VERSION);
            that.version.push('RTM: '+that.AgoraRTM.VERSION);

            //设置密码（暂时没用）
            // that.rtc.client = that.AgoraRTC.createClient({mode: "rtc", codec: "h264"});
            // that.rtc.client.setEncryptionMode('aes-256-xts');

            //记住账号密码
            that.remember = (localStorage.getItem('remember') && localStorage.getItem('remember')) !== 'false';
            if (that.remember) {
                this.ruleForm.room = localStorage.getItem('room')?localStorage.getItem('room'):'';
                that.ruleForm.password = localStorage.getItem('password')?localStorage.getItem('password'):'';
            }
        },
        methods: {
            //设置头像
            set_avatar(key){
                let that = this;
                that.userInfo.avatar2 = key;
            },
            //选择头像
            choose_avatar(){
                let that = this;
                that.dialogVisible = false;
                that.userInfo.avatar1 = that.userInfo.avatar2;
            },
            //提交修改昵称、头像、摄像头、音频等
            submitForm(formName) {
                let that = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //修改
                        localStorage.setItem('avatar',that.userInfo.avatar1);
                        localStorage.setItem('nickname',that.ruleInfoForm.nickname);
                        localStorage.setItem('video',that.userInfo.video);
                        localStorage.setItem('audio',that.userInfo.audio);
                        that.userInfo.avatar = that.userInfo.avatar1;
                        that.userInfo.nickname = that.ruleInfoForm.nickname;

                        that.show = 1;
                    } else {
                        return false;
                    }
                });
            },

            //设备信息
            device(){
                let that = this;

                that.AgoraRTC.getDevices(function(devices){
                    console.log(devices);
                    let video = [];
                    let audio = [];
                    var audioDevices = devices.filter(function(device){
                        if (device.kind === "audioinput"){
                            audio.push({value:device.deviceId,label:device.label});

                            if (that.audio_id == '') {
                                that.audio_id = device.deviceId;
                            }
                        }
                    });
                    var videoDevices = devices.filter(function(device){
                        if (device.kind === "videoinput"){
                            video.push({value:device.deviceId,label:device.label});

                            if (that.video_id == '') {
                                that.video_id = device.deviceId;
                            }
                        }
                    });
                    that.video = video;
                    that.audio = audio;

                    var uid = Math.floor(Math.random()*10000);
                    that.preview = 'preview'+uid;
//                    var selectedMicrophoneId = ...;
//                    var selectedCameraId = ...;
                     that.stream = that.AgoraRTC.createStream({
                        streamID: uid,
                        // Set audio to true if testing microphone
                        audio: true,
                        microphoneId: that.audio_id,
                        // Set video to true if testing camera
                        video: true,
                        cameraId: that.video_id,
                        screen: false
                    });

                    // Initialize the stream
                    that.stream.init(function(){
                        that.stream.play('preview'+uid);
                        // Print the audio level every 1000 ms
//                        setInterval(function(){
//                            console.log(`Local Stream Audio Level ${stream.getAudioLevel()}`);
//                        }, 1000);
                        that.stream.setVideoProfile(that.video_type[that.Resolution]);
                    })
                });
            },

            //修改音频输入
            set_audio(){
                let that = this;
                that.set_leave();
                that.device();
            },
            //修改视频输入
            set_video(){
                let that = this;
                that.set_leave();
                that.device();
            },
            //设置画质清晰度
            set_Profile(){
                let that = this;
                that.set_leave();
                that.device();
            },
            //关闭本地音视频流
            set_leave(){
                let that = this;
                // that.rtc.client.leave(function () {
                    that.stream.stop();
                    that.stream.close();
                // }, function (err) {
                //     console.error(err);
                // });
            },
            //修改音视频设备、画质
            submitDevice(){
                let that = this;
                localStorage.setItem('video_id',that.video_id);
                localStorage.setItem('audio_id',that.audio_id);
                localStorage.setItem('resolution',that.Resolution);
                that.set_leave();
                that.show = 1;
            },
            //提交修改昵称、头像、摄像头、音频等
            submitMain(formName) {
                let that = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //修改
                        localStorage.setItem('room',that.ruleForm.room);
                        localStorage.setItem('password',that.ruleForm.password);

                        // if (that.ruleForm.password !== '') {
                        //     that.rtc.client.setEncryptionSecret(that.ruleForm.password);
                        // }
//                        that.rtc.client.init(that.option.appID, function () {
//                            that.rtc.client.join(that.option.token ? that.option.token : null, that.ruleForm.room, that.option.uid ? +that.option.uid : null, function (uid) {
//
//                                that.rtc.params.uid = uid;
//                                that.rtc.localStream = that.AgoraRTC.createStream({
//                                    streamID: that.rtc.params.uid,
//                                    audio: false,
//                                    video: true,
//                                    screen: false,
//                                });
//                                that.rtc.localStream.init(function () {
//                                    // that.rtc.localStream.play('agora-player-main');
//
//                                    that.rtc.localStream.setVideoProfile(that.video_type[that.Resolution]);
//
//                                        // that.rtc.localStream.disableVideo();
//
//                                    that.rtc.client.publish(that.rtc.localStream, function (err) {
//                                        console.log("publish failed");
//                                        console.error(err);
//                                    })
//                                }, function (err) {
//                                    console.error("init local stream failed ", err);
//                                });
//                                that.rtc.client.on("crypt-error",function (evt) {
//                                    console.log(evt);
//                                });
//                            });
//                        });

                         if (localStorage.getItem('nickname')) {
                             this.$router.push({path:'/main'})
                             localStorage.setItem('remember',that.remember);
                         } else {
                             that.show = 4;
                         }
                    } else {
                        return false;
                    }
                });
            },
            //切换显示版本信息
            show_version(){
                let that = this;
                that.version_num >= 2 ? that.version_num = 0 : ++that.version_num;
            }
        },
        computed : {
            //输入框转大写
            value2Computed : {
                get: function(){
                    return this.ruleForm.room;
                },
                set : function(val){
                    this.ruleForm.room = val.toUpperCase();
                }
            }
        }
    }
</script>

<style>
    body {
        margin: 0;
        font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
        font-size: 14px;
        -webkit-font-feature-settings: "tnum";
        font-feature-settings: "tnum";
        font-variant: tabular-nums;
        line-height: 1.5;
        color: rgba(0, 0, 0, .65);
        background-color: #fff;
    }

    #Index:before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background: url(/static/images/index-background.png) no-repeat 50%;
        right: 0;
        bottom: 0;
        z-index: -2;
    }

    .header {
        width: 100%;
        display: flex;
        align-items: center;
        height: 4rem;
        padding: 25px;
        justify-content: space-between;
        position: absolute;
        top: 0;
        left: 0;
    }

    #Index .main {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-card {
        width: 360px;
        box-shadow: rgba(222, 222, 222, 0.5) 0px 6px 8px 3px;
        font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
        font-size: 14px;
        -webkit-font-feature-settings: "tnum";
        font-feature-settings: "tnum";
        font-variant: tabular-nums;
        line-height: 1.5;
        color: rgba(0, 0, 0, .65);
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        list-style: none;
        background: #fff;
        border-radius: 4px;
        position: relative;
        transition: all .3s;
        border: 1px solid #e8e8e8;
    }

    .ant-card-body {
        padding: 24px;
        zoom: 1;
    }

    .ant-card-body:before {
        content: "";
        display: table;
    }

    .ant-avatar-square {
        border-radius: 4px;
    }

    .ant-avatar-image {
        background: transparent;
    }

    .ant-avatar {
        overflow: hidden;
        vertical-align: middle;
        width: 32px;
        height: 32px;
        line-height: 32px;
        display: inline-block;
    }

    .el-input__icon {
        color: rgba(0, 0, 0, 0.65);
        line-height: normal;
    }

    .ant-divider-horizontal {
        display: block;
        height: 1px;
        width: 100%;
        min-width: 100%;
        margin: 24px 0;
        background: #e8e8e8;
        clear: both;
    }

    input.el-input__inner {
        height: 32px;
    }

    .ant-form-item-label {
        text-align: right;
        color: rgba(0, 0, 0, 0.85);
        line-height: 39.9999px;
    }

    .ant-form-item-label:after {
        content: " ";
        margin: 0 8px 0 2px;
        position: relative;
        top: -.5px;
    }

    .audio-setting {
        margin-bottom: 1.5rem;
    }

    .video-setting {
        display: flex;
        position: relative;
    }

    .video-setting-label {
        color: #333;
        width: 5.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: .5rem;
    }

    .audio-setting-desc, .video-setting-desc {
        color: #666;
        font-size: .7rem;
    }

    .preview-window {
        width: 6rem;
        height: 6rem;
        margin: .5rem;
        background: #fafafa;
    }

    .preview-window>* {
        border-radius: .2rem;
    }

    .el-dialog__header{
        display: none;
    }

    .el-dialog__body{
        border-bottom: 1px solid #e8e8e8;
    }

    .el-dialog__footer{
        padding: 10px 16px;
    }

    .el-avatar>img {
        max-height: 100%;
        max-width: 100%;
        height: auto;
    }

    .el-avatar.active{
        border: 1px solid rgb(5, 188, 245);
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue